exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Avatar{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border:1px solid rgba(178,190,195,0.32);background-color:#DBE0EB;border-radius:50%;color:#7740f9;margin:8px;flex-shrink:0}.Avatar .username{font-weight:bold}.Avatar img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain;background-color:white;border-radius:50%}\n", ""]);

// exports
